<template>
  <div class="page-content || no-top-pad">
    <div class="card">
      <PortraitImage
        :image="content.image"
        :title="content.title"
        :description="content.description"
      />
      <div class="card-header">
        <p class="portrait-label">
          {{ optionData.label }}
        </p>
        <h3 class="portrait-title">
          {{ optionData.description }}
        </h3>
        <p class="card-header-description">{{ optionData.content }}</p>
      </div>
      <CustomButton variation="primary" :onClick="action"
        >Let's get started</CustomButton
      >
    </div>
  </div>
</template>
<script>
import CustomButton from "@/components/CustomButton.vue";
import PortraitImage from "@/components/PortraitImage.vue";
export default {
  components: {
    CustomButton,
    PortraitImage,
  },
  props: {
    action: {
      type: Function,
      required: true,
    },
    content: {
      type: Object,
      required: true,
      default: () => ({
        content: String,
        description: String,
        image: String,
        options: {
          type: Array,
          required: true,
          default: () => [
            {
              id: String,
              label: String,
              to: String,
              icon: String,
              text: String,
              description: String,
              isActive: Boolean,
              target_field: String,
              value: [String, Boolean, Array],
            },
          ],
        },
      }),
    },
  },
  computed: {
    optionData() {
      return this.content.options[0];
    },
  },
};
</script>
